/**
 * 请求配置项
 * 包含 API 配置和 Okta 认证配置
 */

// ============ 环境类型 ============

export type ApiEnv = 'dev' | 'test' | 'prod';

// ============ Okta 配置接口 ============

export interface IOktaConfig {
  host: string;
  clientId: string;
  redirectURI: string;
  scope: string;
}

// ============ 环境配置接口 ============

interface EnvConfig {
  baseUrl: string;
  timeout: number;
  okta: IOktaConfig;
  /** wildwood-cms 权限管理 API 地址 */
  wildwoodCmsHost: string;
}

// ============ Okta 公共配置 ============

const oktaHostTest = 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7';
const oktaHostProd = 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7';
const oktaBase = {
  clientId: 'nike.niketech.tmall-audience-app',
  redirectURI: '/implicit/callback',
  scope: 'openid profile email',
};

// ============ 各环境配置 ============

const ENV_CONFIG: Record<ApiEnv, EnvConfig> = {
  dev: {
    baseUrl: 'http://localhost:3000/api/v1',
    timeout: 30000,
    okta: { ...oktaBase, host: oktaHostTest },
    wildwoodCmsHost: 'https://tmall-origin.gc-uat.nike.com.cn/wildwood/wildwood-cms',
  },
  test: {
    baseUrl: 'https://tmall-aip-api.gc-uat.nike.com.cn/api/v1',
    timeout: 30000,
    okta: { ...oktaBase, host: oktaHostTest },
    wildwoodCmsHost: 'https://tmall-origin.gc-uat.nike.com.cn/wildwood/wildwood-cms',
  },
  prod: {
    baseUrl: 'https://tmall-aip-api.gc.nike.com.cn/api/v1',
    timeout: 30000,
    okta: { ...oktaBase, host: oktaHostProd },
    wildwoodCmsHost: 'https://tmall-origin.gc.nike.com.cn/wildwood/wildwood-cms',
  },
};

// ============ 当前环境 ============

const getEnv = (): ApiEnv => {
  const env = process.env.REACT_APP_API_ENV as ApiEnv;
  if (env && ['dev', 'test', 'prod'].includes(env)) {
    return env;
  }
  return 'dev';
};

export const CURRENT_ENV: ApiEnv = getEnv();

// ============ 导出配置 ============

const currentConfig = ENV_CONFIG[CURRENT_ENV];

// API 配置
export const BASE_URL = process.env.REACT_APP_API_URL || currentConfig.baseUrl;
export const TIMEOUT = currentConfig.timeout;

// Okta 配置
export const OKTA_CONFIG: IOktaConfig = currentConfig.okta;

// Wildwood CMS 权限管理 API 配置
export const WILDWOOD_CMS_HOST =
  process.env.REACT_APP_WILDWOOD_CMS_HOST || currentConfig.wildwoodCmsHost;

// 响应状态码
export const STATUS_CODE = {
  SUCCESS: 0,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  SERVER_ERROR: 500,
};

// ============ 工具函数 ============

/** 获取指定环境的配置 */
export const getEnvConfig = (env: ApiEnv): EnvConfig => ENV_CONFIG[env];

/** 获取所有环境配置 */
export const getAllEnvConfigs = (): Record<ApiEnv, EnvConfig> => ENV_CONFIG;

/** 获取 Okta 配置 */
export const getOktaConfig = (): IOktaConfig => OKTA_CONFIG;
// test husky
